<template>
  <div class="app-view flex h-app flex-col items-stretch overflow-hidden desk:h-auto desk:min-h-screen desk:overflow-visible">
    <AppBar
      class="z-20 flex-none desk:hidden"
      :title="title"
      :backable="backable"
      :back="GoBack"
      :product="product"
      :localable="localable"
    >
      <template #action>
        <slot name="appbar-action" />
      </template>
    </AppBar>
    <header
      v-if="backable && deskHeader"
      class="hidden h-14 flex-none items-center bg-primary px-4 text-white desk:flex desk:border-b desk:border-gray-100 desk:bg-white desk:text-gray-900"
    >
      <button
        v-if="backable"
        type="button"
        class="mr-3 text-sm font-medium text-white hover:opacity-80"
        aria-label="返回上一頁"
        @click="GoBack"
      >
        返回
      </button>
      <h1 class="min-w-0 truncate text-sm font-medium">{{ title }}</h1>
      <div class="ml-auto flex items-center text-white">
        <slot name="appbar-action" />
      </div>
    </header>
    <div
      class="flex flex-grow flex-col overflow-x-hidden overflow-y-scroll scrollbar-hide desk:overflow-visible"
    >
      <div class="flex flex-grow flex-col" :class="orderPage ? 'h-full' : ''">
        <slot />
      </div>
      <AppFooter v-if="footerShow" class="flex-none" />
    </div>
  </div>
</template>

<script>
import AppBar from "./AppBar.vue";
import AppFooter from "./AppFooter.vue";

export default {
  props: {
    title: {
      type: [String, Number],
      default: "",
    },
    backable: {
      type: Boolean,
      default: true,
    },
    deskHeader: {
      type: Boolean,
      default: true,
    },
    footerShow: {
      type: Boolean,
      default: true,
    },
    orderPage: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
    },
    localable: {
      type: Boolean,
      default: true,
    },
  },
  components: { AppBar, AppFooter },
};
</script>
